







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class RestaurantInfo extends Vue {
  @Prop({ required: true }) private name!: string;

  @Prop({ required: true }) private address!: string;
}
